import { DateTime } from 'luxon'

import { PaymentMethodResponseDTO } from '@/core/api/dtos/response/payment/paymentMethod'
import {
	PaymentMethod,
	PaymentPlatformMethodData,
} from '@/core/api/entities/payment/paymentMethod'
import { PaymentPlatformMapper } from '@/core/api/mappers/payment/paymentPlatformMapper'

export class PaymentMethodMapper {
	static toEntity(dto: PaymentMethodResponseDTO): PaymentMethod {
		return PaymentMethod.create({
			id: dto.id,
			paymentPlatformId: dto.payment_platform_id,
			paymentPlatform: dto.payment_platform
				? PaymentPlatformMapper.toEntity(dto.payment_platform)
				: undefined,
			name: dto.name,
			active: dto.active,
			data: dto.data ? PaymentPlatformMethodData.create(dto.data) : undefined,
			createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : undefined,
			updatedAt: dto.updated_at ? DateTime.fromISO(dto.updated_at) : undefined,
		})
	}
	static toEntities(dtos: PaymentMethodResponseDTO[]): PaymentMethod[] {
		return dtos.map(this.toEntity)
	}
}
